// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-findmore[data-v-6e754f16] {\n    margin: 30px 0;\n    box-sizing: border-box;\n}\n@media (min-width: 992px) {\n.btn-findmore[data-v-6e754f16] {\n        width: 263px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
